export default __webpack_public_path__ + "static/media/icon_collapse.fd9a2c31.svg";